module.exports = __webpack_public_path__ + "media/images/course/fausto_banner-cc3010b588abdaa9cefff94963e5cfaa.png";